import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Sidebar = () => {
  const [active, setActive] = useState();
  const navigate = useNavigate();

  const handleActive = (tab) => {
    setActive(tab);
  };

  useEffect(() => {
    setActive("push");
    navigate("/admin-dashboard");
  }, []);
  return (
    <Box
      sx={{
        borderRight: "1px solid #00000080",
        display: "inline-flex",
        flexDirection: "column",
        height: "85vh",
        px: 3,
      }}
    >
      <Link to={"/admin-dashboard"}>
        <Box
          sx={{ color: "#282828", p: 1, mb: 2 }}
          className={active === "push" ? "active" : ""}
          onClick={() => handleActive("push")}
        >
          Push Survey
        </Box>
      </Link>
      <Link to={"/admin-dashboard/completed-surveys"}>
        <Box
          sx={{ color: "#282828", p: 1, mb: 2 }}
          className={active === "completed" ? "active" : ""}
          onClick={() => handleActive("completed")}
        >
          Completed Surveys
        </Box>
      </Link>
      <Link to={"/admin-dashboard/ongoing-surveys"}>
        <Box
          sx={{ color: "#282828", p: 1, mb: 2 }}
          className={active === "ongoing" ? "active" : ""}
          onClick={() => handleActive("ongoing")}
        >
          Ongoing Surveys
        </Box>
      </Link>
      <Link to={"/admin-dashboard/users"}>
        <Box
          sx={{ color: "#282828", p: 1, mb: 2 }}
          className={active === "users" ? "active" : ""}
          onClick={() => handleActive("users")}
        >
          All Users Data
        </Box>
      </Link>
    </Box>
  );
};

export default Sidebar;
